import type { ReactNode } from 'react';

export type SelectOptionType<TValue> = {
  disabled?: boolean;
  label: string;
  content?: ReactNode;
  tooltip?: string;
  value: TValue;
};
type NestedOption<TOptionType> = {
  label: string;
  options: TOptionType[];
};
export type SelectOption<TValue> =
  | SelectOptionType<TValue>
  | NestedOption<SelectOptionType<TValue>>;
export const isNestedOption = <TValue,>(
  option: SelectOptionType<TValue> | NestedOption<SelectOptionType<TValue>>,
): option is NestedOption<SelectOptionType<TValue>> =>
  Object.hasOwnProperty.call(option, 'options');
